import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import NumberFormat from 'react-number-format';
import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import { env } from '../../env';
import { getBanks, getCountries, getTypePayment } from '../../api/settings-payment';

import {
  BANK_NAME,
  WALLET_NAME,
  WEB_MONEY_NAME,
  WESTERN_UNION_NAME,
  CRYPTO_NAME,
  EXCHANGE_NAME,
  CRYPTO_WALLET_NAME
} from '../../constants/type-payment';

import {
  BINANCE_NAME,
  BYBIT_NAME
} from '../../constants/crypto/exchanges';

import {
  TRON_LINK_NAME,
  TRUST_WALLET_NAME
} from '../../constants/crypto/wallets';


const PaymentStaff = ({ onChangeData, disabledButton = false, userId = 'self', data }) => {
  const [listCountries, setListCountries] = useState([]);
  const [listPayment, setListPayment] = useState([]);
  const [listBanks, setListBanks] = useState([]);
  const [loadingUpdateData, setLoadingUpdateData] = useState(false);
  const [loadingCountrySelect, setLoadingCountrySelect] = useState(false);
  const [staffData, setStaffData] = useState({
    currentCountry: {
      label: null,
      value: null
    },
    currentTypePayment: {
      label: null,
      value: null
    },
    currentTypeExchange: {
      label: null,
      value: null
    },
    selectedTypeCrypto: {
      label: null,
      value: null
    },
    selectedOptionCard: {
      label: null,
      value: null
    },
    recipientData: {
      fullName: null,
      phone: null,
      cardNumber: null,
      city: null,
      walletNumber: null,
    }
  });

  useEffect(() => {
    setLoadingCountrySelect(true);

    if (!data) {
      if (userId === 'self') {
        env.http.get('staff/id/').then(response => {
          const id = response.data.data.user_id;
          env.http.get(`staff/${id}`).then(response => {
            const data = response.data;
            setStaffData(data);
            setLoadingCountrySelect(false);
          });
        });
      } else {
        env.http.get(`staff/${userId}`).then(response => {
          const data = response.data;
          setStaffData(data);
          setLoadingCountrySelect(false);
        });
      }
    } else {

      if (!data.currentCountry) {
        data = Object.assign({}, data, staffData)
      }
      setStaffData(data);
      setLoadingCountrySelect(false);
    }

    getCountries(data => {
      setListCountries(data);
    });

  }, []);

  useEffect(() => {
    if (staffData && staffData.currentCountry.value) {
      getTypePayment(staffData.currentCountry.value, data => {
        setListPayment(data);
      });

      getBanks(staffData.currentCountry.value, data => {
        setListBanks(data);
      });
    }
  }, [staffData && staffData.currentCountry]);

  useEffect(() => {
    console.log("Setting list banks");
    if (staffData && staffData.currentCountry.value) {
      getBanks(staffData.currentCountry.value, data => {
        setListBanks(data);
      });
    }
  }, [staffData && staffData.currentTypePayment]);

  useEffect(() => {
    console.log("Setting staffData");
    staffData && onChangeData && onChangeData(staffData);
  }, [staffData]);

  return (
    <div>
      <h2>Страна</h2>

      <Select
        className="profile-page__select"
        placeholder="Выберете страну"
        isLoading={loadingCountrySelect}
        disabled={loadingCountrySelect}
        value={
          staffData &&
          staffData.currentCountry.label && {
            label: staffData.currentCountry.label
          }
        }
        options={listCountries.map(elem => {
          return { id: elem.id, label: elem.title, value: elem.title };
        })}
        onChange={val => {
          if (val.label === staffData.currentCountry.label) return;
          setStaffData({
            ...staffData,
            currentCountry: {
              label: val.label,
              value: val.id
            },
            currentTypePayment: {
              label: null,
              value: null
            },
            selectedOptionCard: {
              label: null,
              value: null
            }
          });
        }}
        searchable={false}
      />

      {staffData && staffData.currentCountry.label && (
        <>
          <h2>Тип перевода</h2>

          <Select
            className="profile-page__select"
            placeholder="Тип перевода"
            value={
              staffData &&
              staffData.currentTypePayment.label && {
                label: staffData.currentTypePayment.label
              }
            }
            options={listPayment.map(elem => {
              return { id: elem.id, label: elem.title, value: elem.title };
            })}
            onChange={val => {
              setStaffData({
                ...staffData,
                currentTypePayment: {
                  label: val.label,
                  value: val.id
                }
              });
              // setSelectedPayment(val);
            }}
            searchable={false}
          />

          {staffData && staffData.currentTypePayment.label === BANK_NAME && (
            <>
              <h2>Банк</h2>

              <Select
                className="profile-page__select"
                placeholder="Выберете банк"
                value={
                  staffData &&
                  staffData.selectedOptionCard.label && {
                    label: staffData.selectedOptionCard.label
                  }
                }
                options={listBanks.map(elem => {
                  return { id: elem.id, label: elem.title, value: elem.title };
                })}
                onChange={val => {
                  setStaffData({
                    ...staffData,
                    selectedOptionCard: {
                      label: val.label,
                      value: val.id
                    }
                  });
                }}
                searchable={false}
              />
            </>
          )}

          {(!staffData || staffData.currentTypePayment.label !== CRYPTO_NAME) && (
            <>
              <h2>Данные получателя</h2>

              <input
                className={`main-form__input main-form__input-full`}
                placeholder="ФИО получателя латинскими буквами"
                value={staffData.recipientData.fullName}
                onChange={e => {
                  setStaffData({
                    ...staffData,
                    recipientData: {
                      ...staffData.recipientData,
                      fullName: e.target.value
                    }
                  });
                }}
              />

              <h3>Номер телефона получателя</h3>

              <input
                className="main-form__input main-form__input-full"
                placeholder="Укажите номер с кодом страны"
                value={staffData.recipientData.phone}
                onChange={e => {
                  setStaffData({
                    ...staffData,
                    recipientData: {
                      ...staffData.recipientData,
                      phone: e.target.value
                    }
                  });
                }}
              />
            </>
          )}

          {staffData && staffData.currentTypePayment.label === BANK_NAME && (
            <>
              <NumberFormat
                className="main-form__input main-form__input-full"
                placeholder="Номер карты"
                format="#### #### #### ####"
                mask="_"
                value={staffData.recipientData.cardNumber}
                onChange={e => {
                  setStaffData({
                    ...staffData,
                    recipientData: {
                      ...staffData.recipientData,
                      cardNumber: e.target.value
                    }
                  });
                }}
              />
            </>
          )}

          {((staffData && staffData.currentTypePayment.label === WALLET_NAME) ||
            (staffData && staffData.currentTypePayment.label === WESTERN_UNION_NAME)) && (
              <>
                <input
                  className="main-form__input main-form__input-full"
                  placeholder="Город получения"
                  value={staffData.recipientData.city}
                  onChange={e => {
                    setStaffData({
                      ...staffData,
                      recipientData: {
                        ...staffData.recipientData,
                        city: e.target.value
                      }
                    });
                  }}
                />
              </>
            )}

          {staffData && staffData.currentTypePayment.label === WEB_MONEY_NAME && (
            <>
              <input
                className="main-form__input main-form__input-full"
                placeholder="Номер кошелька"
                value={staffData.recipientData.walletNumber}
                onChange={e => {
                  setStaffData({
                    ...staffData,
                    recipientData: {
                      ...staffData.recipientData,
                      walletNumber: e.target.value
                    }
                  });
                }}
              />
            </>
          )}
          {staffData && staffData.currentTypePayment.label === CRYPTO_NAME && (
            <>
              <Select
                className="profile-page__select"
                placeholder="Биржа или кошелек"
                value={
                  staffData &&
                  staffData.currentTypeExchange.label && {
                    label: staffData.currentTypeExchange.label
                  }
                }
                options={[
                  { id: 1, label: EXCHANGE_NAME, value: EXCHANGE_NAME },
                  { id: 2, label: CRYPTO_WALLET_NAME, value: CRYPTO_WALLET_NAME }
                ]}
                onChange={val => {
                  setStaffData({
                    ...staffData,
                    currentTypeExchange: {
                      label: val.label,
                      value: val.label
                    },
                    selectedTypeCrypto: {
                      label: null,
                      value: null
                    }
                  });
                }}
                searchable={false}
                required={staffData && staffData.currentTypePayment.label === CRYPTO_NAME}
              />

              {staffData &&
                (staffData.currentTypeExchange.label === EXCHANGE_NAME ||
                  staffData.currentTypeExchange.label === CRYPTO_WALLET_NAME) &&
                (
                  <>
                    <Select
                      className="profile-page__select"
                      placeholder={staffData.currentTypeExchange.label}
                      value={
                        staffData &&
                        staffData.selectedTypeCrypto.label && {
                          label: staffData.selectedTypeCrypto.label
                        }
                      }
                      options={staffData.currentTypeExchange.label === EXCHANGE_NAME ?
                        [
                          { id: 1, label: BINANCE_NAME, value: BINANCE_NAME },
                          { id: 2, label: BYBIT_NAME, value: BYBIT_NAME },
                          { id: 3, label: "Другое", value: "Другое" }
                        ]
                        :
                        [
                          { id: 1, label: TRON_LINK_NAME, value: TRON_LINK_NAME },
                          { id: 2, label: TRUST_WALLET_NAME, value: TRUST_WALLET_NAME },
                          { id: 3, label: "Другое", value: "Другое" }
                        ]
                      }
                      onChange={val => {
                        setStaffData({
                          ...staffData,
                          selectedTypeCrypto: {
                            label: val.label,
                            value: val.label
                          }
                        });
                      }}
                      searchable={false}
                      required={staffData.currentTypeExchange.label !== null}
                    />
                    <h3 style={{marginTop: "15px"}}>Номер кошелька USDT TRC-20</h3>
                    <input
                      className="main-form__input main-form__input-full"
                      placeholder="USDT TRC-20 адрес"
                      required
                      value={staffData.recipientData.walletNumber}
                      onChange={e => {
                        setStaffData({
                          ...staffData,
                          recipientData: {
                            ...staffData.recipientData,
                            walletNumber: e.target.value
                          }
                        });
                      }}
                    />
                  </>
                )
              }
            </>


          )}

          {!disabledButton && (
            <LaddaButton
              className="main-form__submit"
              type="submit"
              data-test-id="submitButton"
              data-color="#eee"
              data-size={XL}
              data-style={SLIDE_UP}
              data-spinner-size={30}
              data-spinner-color="#ddd"
              data-spinner-lines={12}
              loading={loadingUpdateData}
              onClick={() => {

                if (staffData && staffData.currentTypePayment.label === CRYPTO_NAME) {

                  if (!staffData.currentTypeExchange.label) {
                      env.alert('Error', 'Выберите тип поставщика, Биржа или Кошелек');
                    return;
                  }

                  if (!staffData.selectedTypeCrypto.label) {

                    if (staffData.currentTypeExchange.label === EXCHANGE_NAME) {
                      env.alert('Error', 'Выберите биржу');
                    } else {
                      env.alert('Error', 'Выберите кошелек');
                    }
                    return;
                  }
                }


                setLoadingUpdateData(true);

                env.http.post(`/staff/profile/`, staffData).then(
                  (response, reject) => {
                    const data = response.data;
                    setStaffData({ ...staffData, data });
                    setLoadingUpdateData(false);
                    env.alert('Успех', `Данные успешно сохранены`);
                  },
                  reject => {
                    env.alert(
                      'Успех',
                      `Ошибка. Данные не сохранились. <br/>Обратитесь к администратору <br /><br /> Тип ошибки: ${reject}`
                    );
                    setLoadingUpdateData(false);
                  }
                );
              }}
            >
              Обновить данные
            </LaddaButton>
          )}
        </>
      )}
    </div>
  );
};

export default PaymentStaff;
